<div class="row">
    <div *ngIf="!isFirstPage()" class="col-md-offset-2">
        <ul class="timeline">
            <li *ngFor="let step of applicationFlowSteps;" [class]="stepStatus.get(step)">
                <div class="title" routerLink="{{ '/' + step.url() }}">{{ step.displayName() }}</div>
                <div class="description small-text">{{ step.description() }}</div>
            </li>
        </ul>
    </div>

    <div *ngIf="isFirstPage()" class="leftdiv">
        <div class="rightarrowintro"></div>
        <div class="leftinnerdiv">
            <p class="lefttxt">Hello there!</p>
            <p class="lefttxt2">Welcome to finzy</p>
        </div>
        <div class="leftarrowintro"></div>
    </div>
</div>